import { DeleteListModal } from './DeleteListModal';

export const Modals = () => (
  <>
    {/* Add all modals for List Index Page here */}
    <DeleteListModal />
  </>
);
